import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { useInteractionsTeams } from '@/views/Interactions/hooks/useInteractionsTeams';
import {
  type InteractionTypeFilter,
  interactionsTeamsState,
  useToggleFilter,
} from '@/views/Interactions/state/filters';
import { FilterAutocomplete } from '../FilterAutocomplete';

interface Props {
  type: InteractionTypeFilter;
  stateKey: string;
  hideLabel?: boolean;
}

export function TeamsFilter({ type, stateKey, hideLabel }: Props) {
  const { teams, loading } = useInteractionsTeams();
  const [currentTeams, setCurrentTeams] = useAtom(
    interactionsTeamsState(stateKey),
  );
  const toggleTeam = useToggleFilter(stateKey);
  const clearAllTeams = useCallback(
    () => setCurrentTeams([]),
    [setCurrentTeams],
  );

  if (loading || teams.length < 2) {
    return null;
  }

  return (
    <FilterAutocomplete
      type={type}
      filterType="teams"
      eventContainer="agent_team_filter"
      label="Team"
      value={currentTeams}
      options={teams}
      onClear={clearAllTeams}
      onToggle={toggleTeam}
      hideLabel={hideLabel}
    />
  );
}
